// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"06839691","947":"19838bd8"}[chunkId] + ".chunk.js";
};